import { db } from '@/main';
import router from '@/router'

export const namespaced = true

export const state = {
	businesses: [],
	customer: {
		id: '',
		name: ''
	},
	business: {
		id: null,
		active: true,
		address: '',
		customer_id: '',
		customer_name: '',
		facebook: '',
		instagram: '',
		name: '',
		phone: '',
		photo_name: '',
		photo_url: '',
		twitter: '',
		color: '',
	},
	dialog: false,
	editMode: false,
}

export const mutations = {
	SET_BUSINESS(state, data) {
		state.business = data
	},
	SET_CUSTOMER(state, data) {
		state.customer = data
	},
	SET_BUSINESSES(state, data) {
		state.businesses = data
	},
	SET_BUSINESS_DIALOG: (state, data) => {
		state.dialog = !state.dialog;
		state.editMode = data.editMode;
		state.business = data.business;
	},
}

export const actions = {
	getbusinesses({ commit, dispatch }) {
		return new Promise(resolve => {
			db.collection('bussiness').onSnapshot(function (querySnapshot) {
				let businesses = [];
				querySnapshot.forEach((doc) => businesses.push(doc.data()))
				commit('SET_BUSINESSES', businesses);
				dispatch('setLoaded', true, { root: true })
				resolve();
			})
		});
	},
	toggleBusinessDialog({ commit }, data) {
		commit('SET_BUSINESS_DIALOG', data);
		commit('SET_CUSTOMER', { id: data.business.customer_id, name: data.business.customer_name });
	},
	setBusiness({ commit }, data) {
		commit('SET_BUSINESS', data)
	},

	async setLocalBusiness({commit}, id){
		const buss = window.localStorage.getItem("buss");

		var update = true;
		if (buss) {
			if (JSON.parse(buss).id === id) {
				commit("SET_BUSINESS", JSON.parse(buss));
				update = false;
			} 
		}
		// console.log(id)
		// console.log(JSON.parse(buss).id)

		if (update) {
			try {
				await db.collection('bussiness').doc(id).get()
					.then((doc) => {
						if (doc.exists) {
							commit("SET_BUSINESS", doc.data());
							window.localStorage.setItem("buss", JSON.stringify(doc.data()));
						} else { 
							console.log("No such document!");
							localStorage.removeItem('buss');
							router.push({name: 'Home'})
						}
					}).catch(function (error) {
						console.log("Error en el documento:", error);
					});

			} catch (error) { console.log('Algo salio mal') }
		}
		
				
			
				
		// 		fetch("https://randomuser.me/api/?results=100")
		// 			.then(data => data.json())
		// 			.then(data => {
		// 				commit("setUsers", data.results);
		// 				window.localStorage.setItem(
		// 					"users",
		// 					JSON.stringify(data.results)
		// 				);
		// 			});
		// 	} catch (error) {
		// 		console.error(error);
		// 	}
		
		// }
		// console.log('---- '+id)
	}

}

export const getters = {
	businessesDialog: (state) => {
		return state.dialog;
	},
	businessForEdit: (state) => {
		return state.business;
	},
	businessDialogEditMode: (state) => {
		return state.editMode;
	},
	customerForEdit: (state) => {
		return state.customer
	}
}